// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as NoteComponent} from './Note.svg';

import Icon, { TIconProps } from '../Icon';

export const IconNote = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <NoteComponent/>
  </Icon>
));
